import NetInfo from "@react-native-community/netinfo";

export const createNoopSubscription = () => ({
  unsubscribe() {},
});

const canAttemptSubscription = (state) =>
  state?.isConnected !== false && state?.isInternetReachable !== false;

export const safeGraphqlSubscribe = ({ client, request, observer }) => {
  let subscription = createNoopSubscription();
  let removeNetInfoListener;
  let cancelled = false;

  const notifyError = (error) => {
    if (!cancelled) {
      observer?.error?.(error);
    }
  };

  const startSubscription = () => {
    if (cancelled) return;

    try {
      subscription = client.graphql(request).subscribe(observer);
    } catch (error) {
      notifyError(error);
    }
  };

  NetInfo.fetch()
    .then((state) => {
      if (canAttemptSubscription(state)) {
        startSubscription();
        return;
      }

      removeNetInfoListener = NetInfo.addEventListener((nextState) => {
        if (!canAttemptSubscription(nextState)) {
          return;
        }

        removeNetInfoListener?.();
        removeNetInfoListener = undefined;
        startSubscription();
      });
    })
    .catch(startSubscription);

  return {
    unsubscribe() {
      cancelled = true;
      removeNetInfoListener?.();
      subscription.unsubscribe();
    },
  };
};
